module.exports = __webpack_public_path__ + "img/20191021163647881.38b2867a.jpg";